enum MortgageStatic {
  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @type public
   * @description get agencies list
   */
  Mortgage_referral_create = "/v2/mortgage/referral",

  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @type public
   * @description get mortgage list
   */
  Mortgage_List = "/v2/mortgage/"
}

const MortgageDynamic = {
  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @description google social network login
   */
  Mortgage_Detail: (id: string | number) => `/v2/mortgage/${id}`,

  /**
   * Endpoint para actualizar un referimiento hipotecario existente.
   */
  Mortgage_Update: (id: string | number) => `/v2/mortgage/${id}?_method=PUT`,

  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @description google social network login
   */
  Mortgage_Update_Status: (id: string | number) => `/v2/mortgage/${id}/status`
};

export const MortgageEndpoints = {
  ...MortgageDynamic,
  ...MortgageStatic
};

export type MortgageEndpoints = typeof MortgageEndpoints;
